import React from 'react';
import { motion } from 'framer-motion';
export function CtaFinal() {
  return <section className="py-32 bg-brand-black relative overflow-hidden border-t border-white/5" data-id="element-90">
      {/* Dramatic Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-91" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-brand-green/10 blur-[120px] rounded-full pointer-events-none" data-id="element-92" />

      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.02] bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" data-id="element-93" />

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto" data-id="element-95">
          <h2 className="font-heading text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg" data-id="element-96">
            ¿Listo para dominar tu zona?
          </h2>

          <p className="text-xl md:text-2xl text-brand-gray mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-97">
            Deja de perder tiempo con leads basura. Nosotros te traemos los
            contratos grandes.
          </p>

          <div className="flex flex-col items-center space-y-6" data-id="element-98">
            <motion.a href="#contact-form" whileHover={{
            scale: 1.05,
            boxShadow: '0 0 40px rgba(212, 168, 67, 0.3)'
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-brand-yellow text-brand-black font-heading font-bold text-2xl px-12 py-6 rounded-md uppercase tracking-wider transition-all duration-300 relative overflow-hidden group w-full sm:w-auto" data-id="element-99">
              <span className="relative z-10" data-id="element-100">
                Fumigar Mi Competencia Ahora
              </span>
              <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-101" />
            </motion.a>

            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="flex items-center text-brand-gray hover:text-white transition-colors group text-lg" data-id="element-102">
              <svg className="w-5 h-5 mr-2 text-brand-yellow group-hover:scale-110 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-103">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-104"></rect>
                <line x1="16" y1="2" x2="16" y2="6" data-id="element-105"></line>
                <line x1="8" y1="2" x2="8" y2="6" data-id="element-106"></line>
                <line x1="3" y1="10" x2="21" y2="10" data-id="element-107"></line>
              </svg>
              <span className="underline decoration-brand-gray/50 underline-offset-4 group-hover:decoration-brand-yellow/50" data-id="element-108">
                Agenda tu cita en nuestro calendario →
              </span>
            </a>

            <p className="text-sm text-brand-gray/70 mt-4 uppercase tracking-widest font-medium" data-id="element-109">
              Diagnóstico 100% gratuito · Sin compromiso · Resultados en 48-72
              horas
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}